import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found - onBookmarks</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <section className="py-5">
        <div className="container">
          <div className="row min-vh-75 align-items-center">
            <div className="col-lg-8 mx-auto text-center">
              <div className="mb-4">
                <span className="display-1 fw-bold text-primary">404</span>
              </div>
              <h1 className="h2 fw-bold mb-3">Page Not Found</h1>
              <p className="lead text-muted mb-4">
                The page you're looking for doesn't exist or has been moved.
              </p>
              <div className="d-flex gap-3 justify-content-center flex-wrap">
                <Link to="/" className="btn btn-primary btn-lg">
                  Go to Homepage
                </Link>
                <Link to="/features" className="btn btn-outline-primary btn-lg">
                  Explore Features
                </Link>
              </div>

              <div className="mt-5 pt-4 border-top">
                <p className="text-muted mb-3">Looking for something specific?</p>
                <div className="d-flex gap-2 justify-content-center flex-wrap">
                  <Link to="/pricing" className="btn btn-sm btn-light">
                    Pricing
                  </Link>
                  <Link to="/download/extensions" className="btn btn-sm btn-light">
                    Browser Extensions
                  </Link>
                  <Link to="/docs" className="btn btn-sm btn-light">
                    Documentation
                  </Link>
                  <Link to="/about" className="btn btn-sm btn-light">
                    About Us
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFound;
